<template>
    <div>
        <h2 class="mb-4 font-weight-bold">
            {{ $t('gpdr.cookieDisclaimer.mainPage.title') }}
        </h2>
        <div>
            <div class="my-4 text-subtitle-1 font-weight-bold">
                {{ $t('gpdr.cookieDisclaimer.mainPage.subtitle') }}
            </div>
            <span v-html="$t('gpdr.cookieDisclaimer.mainPage.body1')"/>
            <a
                href="#"
                @click.prevent="openSettings"
            >
                {{ $t('gpdr.cookieDisclaimer.userSettings') + '.' }}
            </a>
        </div>

        <div class="mt-4">
            <span v-html="$t('gpdr.cookieDisclaimer.mainPage.body2')"/>
            <a
                :href="gpdrUrl"
                target="habiteo_policies"
            >
                {{ $t('gpdr.cookieDisclaimer.cookiePolicies') + '.' }}
            </a>
        </div>
        
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';

    export default {
        name: 'DisclaimerMainPage',
        computed: {
            ...mapGetters([
                'language'
            ]),
            gpdrUrl() {
                let lang;
                switch (this.language) {
                    case 'ca':
                        lang = 'en';
                    break;

                    default:
                        lang = this.language;
                    break;
                }
                return `https://wiki.habiteo.com/${lang}/legal/cookie-policy-megawidget`;
            }
        },
        methods: {
            openSettings() {
                this.$emit('open-settings');
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/gdpr/pages/MainPage.vue